<template>
  <section v-if="user" class="col-lg-8">
    <!-- Toolbar-->
    <div class="d-none d-lg-flex justify-content-between align-items-center pt-lg-3 pb-4 pb-lg-5 mb-lg-3">
      <h6 class="fs-base text-light mb-0">Pas je gegevens aan:</h6>
      <a @click="logout" class="btn btn-primary btn-sm"><i class="ci-sign-out me-2"></i>Uitloggen</a>
    </div>
    <!-- Profile form-->
    <form>
      <div class="bg-secondary rounded-3 p-4 mb-4">
        <div class="d-flex align-items-center"><img class="rounded" src="data:image/gif;base64,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" width="90" alt="">

        </div>
      </div>
      <div class="row gx-4 gy-3">
        <div class="col-sm-6">
          <label class="form-label" for="account-fn">Voornaam</label>
          <input class="form-control" type="text" id="account-fn" v-model="user.firstName">
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="account-ln">Achternaam</label>
          <input class="form-control" type="text" id="account-ln" v-model="user.lastName">
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="account-email">Email adres</label>
          <input class="form-control" type="email" id="account-email" v-model="user.emailAddress">
        </div>
        <div class="col-sm-6">

        </div>
        <div class="col-sm-6">
          <label class="form-label" for="account-pass">Nieuw wachtwoord</label>
          <div class="password-toggle">
            <input class="form-control" type="password" id="account-pass" data-lpignore="true" autocomplete="new-password" v-model="newPasssword1">
            <div :style="{display:wrongPassword?'block':'none'}" class="invalid-feedback">Vul twee keer hetzelfde wachtwoord in.</div>

          </div>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="account-confirm-pass">Bevestig wachtwoord</label>
          <div class="password-toggle">
            <input class="form-control" type="password" id="account-confirm-pass" data-lpignore="true" autocomplete="new-password" v-model="newPasssword2">
            <div :style="{display:wrongPassword?'block':'none'}" class="invalid-feedback">Vul twee keer hetzelfde wachtwoord in.</div>

          </div>
        </div>
        <div class="col-12">
          <hr class="mt-2 mb-3">
          <div class="d-flex flex-wrap justify-content-between align-items-center">
<!--            <button class="btn btn-primary mt-3 mt-sm-0"  @click="saveUser" type="button">Profiel opslaan</button>-->
            <save-button @beforeClick="checkPasswords" @click="saveUser" :can-click="validated" button-text="Profiel opslaan"></save-button>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import SaveButton from "@/components/gui/SaveButton";
export default {
  name: "MyAccountProfile",
  data() {
    return {
      newPasssword1: "",
      newPasssword2: "",
      wrongPassword: false,
      validated: false,
    }
  },
  components: {
    SaveButton
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.replace('/verhuur');
    },
    checkPasswords() {
      if (this.newPasssword1 !== this.newPasssword2) {
        this.wrongPassword = true;
        return false;
      }
      this.validated = true;
    },
    saveUser() {
      if (this.newPasssword1 !== '' || this.newPasssword2 !== '') {
        this.user.newPassword = this.newPasssword1
        this.$store.dispatch('saveUser', this.user);
      } else {
        this.$store.dispatch('saveUser', this.user);
      }
      this.wrongPassword = false;
      this.validated = false;
      this.newPasssword1 = "";
      this.newPasssword2 = "";
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  }
}
</script>

<style scoped>

</style>